import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=786648ad&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786648ad')) {
      api.createRecord('786648ad', component.options)
    } else {
      api.reload('786648ad', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=786648ad&", function () {
      api.rerender('786648ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RDsWZB1Iwlrr/JS/comp/ImgFallback.vue"
export default component.exports